import './SalesforceSetupPanel.scss';
import { ADMIN_DASHBOARD_COPY } from '@sonar-software/sonar-ts-constants';
import { Button } from 'antd';
import { useAction } from '@hooks';
import { coreActions } from '@sonar-software/sonar-core';
import React, { useCallback } from 'react';
export const SalesforceOrgSyncSecurityAlertsControls = ({ organization }) => {
    const startSyncSecurityAlerts = useAction(coreActions.requestPostCoreSyncSecurityAlerts);
    const handleSyncSecurityAlerts = useCallback(() => {
        if (organization) {
            startSyncSecurityAlerts({
                organizationId: organization.id
            });
        }
    }, [startSyncSecurityAlerts, organization]);
    return organization ?
        React.createElement("div", null,
            React.createElement(Button, { className: 'sync-security-alerts-button', onClick: handleSyncSecurityAlerts }, ADMIN_DASHBOARD_COPY.SYNC_SECURITY_ALERTS)) :
        null;
};
